import { render, staticRenderFns } from "./CargueInterco.vue?vue&type=template&id=b1c5f3be"
import script from "./CargueInterco.vue?vue&type=script&lang=js"
export * from "./CargueInterco.vue?vue&type=script&lang=js"
import style0 from "../main.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports